<template>
  <div class="flex flex-col items-stretch justify-start">
    <div
      class="mb-4 flex flex-wrap items-center justify-between cursor-pointer"
      @click="() => (isCollapse = !isCollapse)"
    >
      <div class="flex items-center justify-start gap-1">
        <div class="text-sm flex items-start justify-start">
          <span v-if="required" class="element-asterisk">*</span>
          <label class="el-form-item__label m-0 p-0">{{ title }}</label>
        </div>
        <el-tooltip v-if="infoText && infoText.length > 0" placement="top">
          <template #content
            ><div class="max-h-41 overflow-y-auto whitespace-pre-line">
              {{ infoText }}
            </div></template
          >
          <svg-icon iconName="info-circle-icon" className="tooltip-icon" />
        </el-tooltip>
        <div v-if="isCollapse && answerLabel.length > 0" class="ml-1 md:ml-2 text-sm text-blackG4 leading-none">
          <el-tooltip class="block sm:hidden md:block lg:hidden DEVICE_SIZE_LAPTOP:block 1240px:hidden" placement="top">
            <template #content>
              <div class="max-h-41 overflow-y-auto whitespace-pre-line">
                {{ answerLabel }}
              </div></template
            >
            <svg-icon iconName="info-circle-icon" className="tooltip-icon" @click.stop.prevent="() => {}" />
          </el-tooltip>
          <div class="hidden sm:block md:hidden lg:block DEVICE_SIZE_LAPTOP:hidden 1240px:block">
            {{ answerLabel }}
          </div>
        </div>
      </div>
      <div v-if="expandable" class="flex items-center justify-start gap-1.5">
        <div v-if="expandLabel.length > 0" class="text-sm font-semibold text-blackG3">
          {{ $t(expandLabel).toUpperCase() }}
        </div>
        <i :class="isCollapse ? 'el-icon-arrow-down' : 'el-icon-arrow-up'" class="text-lg text-black" />
      </div>
    </div>
    <div
      :class="[
        ...(expandable
          ? [
              isCollapse ? maxHeightTransition : 'max-h-1000',
              isCollapse && maxHeightTransition === 'max-h-0' ? 'py-0' : 'py-1',
              ' overflow-hidden'
            ]
          : []),
        gap
      ]"
      class="flex flex-wrap items-end justify-start overflow-visible transition-max-height duration-300 ease-in-out"
    >
      <slot :isCollapse="isCollapse" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'RegisterCollapseRow',
  props: {
    required: { type: Boolean, default: false },
    expandable: { type: Boolean, default: false },
    title: { type: String, required: true },
    infoText: { type: String, default: '' },
    // custom the max-height for collapse
    // required when expandable
    maxHeightTransition: { type: String, default: '' },
    defaultCollapse: { type: Boolean, default: true },
    gap: { type: String, default: 'gap-4 md:gap-x-10 md:gap-y-6' },
    answerLabel: { type: String, default: '' },
    expandLabel: { type: String, default: 'common.all' }
  },
  data() {
    return { isCollapse: true };
  },
  watch: {
    defaultCollapse() {
      this.isCollapse = this.defaultCollapse;
    }
  },
  mounted() {
    this.isCollapse = this.defaultCollapse;
  },
  methods: {}
};
</script>
<style lang="scss" scoped>
.overflow-hidden {
  overflow: hidden !important;
}
</style>
